import cn from 'classnames';

import rightArrowIcon from '@app/assets/icons/right-arrow.svg';
import type { ArrowIconButtonType } from '@app/components/Calendars/components/ArrowIconButton/types';
import '@app/components/Calendars/components/ArrowIconButton/styles/ArrowIconButton.desktop.scss';

export const ArrowIconButton: ArrowIconButtonType = ({
  isVisible = false,
  isEmpty = false,
  direction,
  ...props
}) => {
  if (!isVisible) return <></>;
  if (isEmpty) return <div className="box"></div>;

  return (
    <button className="arrow-icon-button-container box" {...props}>
      <img
        className={cn({ rotate: direction === 'left' })}
        src={rightArrowIcon}
        alt={direction}
      />
    </button>
  );
};
